import { render, staticRenderFns } from "./UnlockingContents.vue?vue&type=template&id=44064142&scoped=true&"
import script from "./UnlockingContents.vue?vue&type=script&lang=js&"
export * from "./UnlockingContents.vue?vue&type=script&lang=js&"
import style0 from "./UnlockingContents.vue?vue&type=style&index=0&id=44064142&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44064142",
  null
  
)

export default component.exports